module.exports = __webpack_public_path__ + "Flag-807.57947a8cb6d008d82ad29473db1c15fd.svg";